export default {
    error: ({auth}) => auth.error,
    buttons: {
        auth: ({auth}) => auth.buttons.auth,
        guest: ({auth}) => auth.buttons.guest
    }
}